// import request from '@/router/axios'
import {request} from '@/network/request'
// export function fetchList(query) {
//   return request({
//     url: '/gaoligong/spineAnimal/page',
//     method: 'get',
//     params: query
//   })
// }
export function fetchList(data) {
  return request({
    url: '/gaoligong/dnabarzoo/getDnaBarZooList',
    method: 'post',
    data:data
  })
}
export function getStripFragmentList() {
  return request({
    url: '/gaoligong/dnabarzoo/getStripFragmentList',
    method: 'get'
  })
}
